import { render } from "./HeaderColumn.vue?vue&type=template&id=642150e2&scoped=true"
import script from "./HeaderColumn.vue?vue&type=script&lang=js"
export * from "./HeaderColumn.vue?vue&type=script&lang=js"

import "./HeaderColumn.vue?vue&type=style&index=0&id=642150e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-642150e2"

export default script